import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { setPostSuccessTransaction } from '../../users/store/thunk/setPostSuccessTransaction';
import { setGetReplenishment } from '../store/thunk/setGetReplenishment';

const useStyles = makeStyles(() => ({
    root: {
        position: 'fixed',
        top: 0,
        left: 0,
        background: 'rgba(0,0,0,0.2)',
        height: '100vh',
        width: '100vw',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    form: {
        background: '#fff',
        borderRadius: 8,
        padding: 20,
        display: 'flex',
        flexDirection: 'column',
        minWidth: 500
    },
    field: {
        padding: 10,
        paddingLeft: 10,
        border: '1px solid #141b33',
        outline: 'none',
        margin: 10,
        color: '#000',
        width: 'calc(100% - 40px)',
        '&::placeholder': {
            color: '#000'
        }
    },
    btn: {
        padding: '10px 15px',
        borderRadius: 4,
        background: 'gold',
        color: '#000',
        cursor: 'pointer',
        border: 'none',
        fontSize: 18
    }
}))

const ConfirmTransaction = ({
    handleChange
}) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = React.useState(false);

    const {
        register,
        handleSubmit
    } = useForm()

    const onSubmit = (store) => {
        if (store.transaction && !isLoading) {
            setIsLoading(true);
            dispatch(setPostSuccessTransaction(store, () => {
                dispatch(setGetReplenishment({
                    page: 1, 
                    rowsPerPage: 10,
                    order: 'id',
                    desc: false,
                    search: '',
                    date_from: 0,
                    date_to: new Date().getTime(),
                }));
                setIsLoading(false);
                handleChange();
            }))
        }
    }

    return (
        <div className={classes.root}>
            <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
                <label htmlFor="transaction">
                    <input
                        {...register('transaction')}
                        type="text"
                        placeholder="ID транзакции"
                        className={classes.field}
                    />
                </label>
                <button
                    type="submit"
                    className={classes.btn}
                >
                    Выполнить
                </button>
            </form>
        </div>
    )
}

export default ConfirmTransaction;